import React, { useCallback, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { TripReportContext, TripReportStore } from '@this/src/domain/trip_report/trip_report_store';
import { TripReportForm } from './trip_report_form/trip_report_form';

interface Props {
  serviceId: number;
  allowanceAvailable: boolean;
}

export const TripReportEdit: React.FC<Props> = ({ serviceId, allowanceAvailable }) => {
  const { id } = useParams<{ id: string }>();
  const tripReports = useMemo(() => new TripReportStore({ serviceId, loading: true, allowanceAvailable }), []);

  const fetchTripReports = useCallback(() => {
    // getMenus は完了時に loading を解除するため、初期取得と並走させず完了後に呼ぶ
    Promise.all([tripReports.getShow(id), tripReports.getTrips(id)]).then(() => tripReports.getMenus());
  }, [id]);

  useEffect(() => {
    fetchTripReports();
  }, [fetchTripReports]);

  return (
    <TripReportContext.Provider value={tripReports}>
      <TripReportForm />
    </TripReportContext.Provider>
  );
};
